'use client';

import {
	AutoPopupHandlerProvider,
	DEFAULT_AUTO_POPUP_ORDER,
} from '@nf/auto-popup-handler';
import type { ReactNode } from 'react';

export const AutoPopupHandlerRoot = ({ children }: { children: ReactNode }) => (
	<AutoPopupHandlerProvider orderConfig={DEFAULT_AUTO_POPUP_ORDER}>
		{children}
	</AutoPopupHandlerProvider>
);
